module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qhand3-0183a04d7406059574a18ff44ecaf835.jpg";